/**
 * 滚动控制相关的原子
 * 用于控制消息列表的自动滚动行为
 */
import { atom } from 'jotai';

// 是否应该自动滚动到底部
// true: 自动滚动到底部（默认，发送消息后）
// false: 不自动滚动（用户手动滚动后）
export const shouldAutoScrollAtom = atom<boolean>(true);
